'use client';

import * as React from 'react';
import clsx from 'clsx';
import { FocusableLink, type FocusableLinkProps } from 'ui';
import styles from './link.module.css';

export type RootLinkProps = FocusableLinkProps;

export const RootLink = React.forwardRef(function LinkImpl(
  { ...props }: RootLinkProps,
  ref: React.Ref<HTMLAnchorElement>,
): JSX.Element {
  const [target, setTarget] = React.useState(props.target);
  React.useEffect(() => {
    if (
      !props.href.startsWith('/') &&
      !props.href.startsWith(window.location.origin)
    ) {
      setTarget('_blank');
    }
  }, [props.href]);
  return (
    <FocusableLink
      {...props}
      className={clsx('no-underline', styles.underline, props.className)}
      ref={ref}
      target={props.target || target}
    />
  );
});
